import React from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  valueContainer: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    maxWidth: 170,
    height: 50,
    marginLeft: 16,
    overflow: 'hidden',
  },
});

const ValueContainer = ({ children }) => {
  const classes = useStyles();

  return <div className={classes.valueContainer}>{children}</div>;
};

export default ValueContainer;
